/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { GAData, Path, Progress } from "../_common/constant/page-const";
import { ESRMainValidation } from './ESR_main.validator';
import { ViewportScroller } from '@angular/common';
import { ItemList } from 'src/app/_common/constant/item-list';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { Code } from 'src/refresh/service/constant';
import { ProgressService } from 'src/refresh/service/progress-service';
import { TranslateService } from '@ngx-translate/core';
import { Util } from 'src/refresh/service/Util';
import { CommonService } from 'src/refresh/service/common-service';

@Component({
      selector: 'ESR_main',
      templateUrl: './ESR_main.component.html',
      styleUrls: ['./ESR_main.component.less']
})
export class ESRMainComponent extends FormBaseComponent implements OnInit {

      public childNameParam: Object;
      public childPOBParam: Object;

      public promoterList: Map<number, string> = new Map<number, string>();

      public error_noParent: string = '';
      public error_category: string = '';
      public error_promoter: string = '';
      public error_postalCode: string = '';
      public error_country: string = '';
      public error_contactMethod: string = '';
      public error_email: string = '';
      public error_notice: string = '';
      public error_disclaimer: string = '';
      public error_consent: string = '';
      public error_disclosure: string = '';
      public error_phoneNumber: string = '';
      public error_secondPhoneNumber: string = '';

      public categoryDesc: string = "";

      private noticeBoxOpen: boolean = false;
      private discBoxOpen: boolean = false;
      private consBoxOpen: boolean = false;

      public contactMorning:boolean = false;
      public contactAfternoon:boolean = false;

      @ViewChild('noticeBox') noticeBox: LightBox;
      @ViewChild('discBox') discBox: LightBox;
      @ViewChild('consBox') consBox: LightBox;

      ESRMainValidation:ESRMainValidation;

      constructor(protected router: Router,
            public timerService: TimerService,
            public viewportScroller: ViewportScroller,
            public items: ItemList,
            protected progress: ProgressService,
            public data: InputData,
            public translateService: TranslateService,
            private commonService: CommonService,
            private elemRef: ElementRef) {

            super(router, timerService);

            let prevPage = !this.data.SIN.chk_read? Path.SINAreYouSure : Path.SINMain;
            super.setNextPage(Path.OrderSummary,prevPage);
            this.ESRMainValidation = new ESRMainValidation(this);
            super.setValidator(new ESRMainValidation(this));           

            if ( this.data.CESP.category == 'X' ) {
                 this.data.CESP.category = '';
                 super.forward();
                 return;
            }            

            this.childNameParam = { childName: data.aboutChild.name.getFullName() };
            this.childPOBParam = { childPOB: this.getBirthDate(data.aboutChild.birthDay) };

            if ( Util.isEmpty(data.CESP.postalCode) )
                 data.CESP.postalCode = data.contact.address.postalCode;
            if ( Util.isEmpty(data.CESP.country) )
                 data.CESP.country = this.getCountryName();

            if (data.CESP.category) {
                  this.promoterList = new Map<number, string>(this.items.promoterList[data.CESP.category]);
            }

            this.commonService.getCloseLightBox().subscribe((r) =>{
                  if(this.noticeBoxOpen) this.notAgreeNoticeClose();
                  if(this.discBoxOpen) this.notAgreeDiscClose();
                  if(this.consBoxOpen) this.notAgreeConsClose();
            });

            if ( this.data.CESP.contactTime >= 2 ) {
                  this.contactAfternoon = true;
                  if ( this.data.CESP.contactTime == 3 ) this.contactMorning = true;
            }
            else 
            if ( this.data.CESP.contactTime == 1 ) 
                 this.contactMorning = true;

            InputData.currentPageIdx = 22;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      private getCountryName() {
            let countryCode = this.data.contact.address.base.country;
            if (countryCode == Code.NotFound) {
                  return this.data.contact.address.base.otherCountry;
            }
            else return this.items.countryList.get(countryCode);
      }

      public ngOnInit() {
             super.forwardNext(InputData.currentPageIdx)
      }

      public scrollDown() {
            this.viewportScroller.scrollToAnchor('bottom');
            return false;
      }

      public categoryChanged() {
            this.promoterList = new Map<number, string>(this.items.promoterList[this.data.CESP.category]);
            this.data.CESP.promoter = "";
            this.categoryDesc = this.items.categoryDescList[this.data.CESP.category];
      }

      public onNextClick() : boolean {

            if ( super.onNextClick() ) {

                 if ( this.contactMorning ) {
                      if ( this.contactAfternoon ) this.data.CESP.contactTime = 3;
                      else                         this.data.CESP.contactTime = 1;
                 }
                 else
                 if ( this.contactAfternoon ) this.data.CESP.contactTime = 2;
                 else                         this.data.CESP.contactTime = null;

                 this.progress.progressStatus[Progress.ESR] = 2;
                 super.gtag(GAData.Button, GAData.continue_product);
            }
            else this.progress.progressStatus[Progress.ESR] = 1;
            return true;
      }

      validateCotactSelection(){
            if ( Util.isEmptyNumber(this.data.CESP.contactParent) || this.data.CESP.contactParent == -1 ) {
                  this.focus('selParent','radio_certifyingParentsRadio_0');
                  this.error_noParent = "ESR_main.errNoParent"; 
                  return false;
            }
            return true;
      }

      public showNotice($event) {
            $event.preventDefault();
            if(this.validateCotactSelection()){
                  this.noticeBoxOpen = true;
                  this.noticeBox.open();
            }else{
                  this.error_notice = '';
                  $event.target.offsetParent.querySelector('input').checked = false;
            }
           
      }

      validateDisclosure($event){
            if(!this.validateCotactSelection()){
                  this.error_notice = '';
                  $event.target.offsetParent.querySelector('input').checked = false;
            }
      }

      public agreeNoticeClose() {
            this.error_notice = '';
            this.data.CESP.chk_privacy = true;
            this.noticeBoxOpen = false;
            this.noticeBox.close();
      }

      public notAgreeNoticeClose() {
            this.data.CESP.chk_privacy = false;
            this.noticeBoxOpen = false;
            this.noticeBox.close();
      }

      public showDisclaimer($event) {
            $event.preventDefault();
            if(this.validateCotactSelection()){
                  this.discBoxOpen = true;
                  this.discBox.open();
            }else{
                  this.error_disclaimer = '';
                  $event.target.offsetParent.querySelector('input').checked = false;
            }
      }

      public agreeDiscClose() {
            this.error_disclaimer = '';
            this.data.CESP.chk_disclaimer = true;
            this.discBoxOpen = false;
            this.discBox.close();
      }

      public notAgreeDiscClose() {
            this.data.CESP.chk_disclaimer = false;
            this.discBoxOpen = false;
            this.discBox.close();
      }

      public showConsent($event) {
            $event.preventDefault();
            if(this.validateCotactSelection()){
                  this.consBoxOpen = true;
                  this.consBox.open();
            }else{
                  this.error_consent = '';
                  $event.target.offsetParent.querySelector('input').checked = false;
            }
      }

      public agreeConsClose() {
            this.error_consent = '';
            this.data.CESP.chk_consent = true;
            this.consBoxOpen = false;
            this.consBox.close();
      }

      public notAgreeConsClose() {
            this.data.CESP.chk_consent = false;
            this.consBoxOpen = false;
            this.consBox.close();
      }

      public dontRequest() {
            this.data.CESP.chk_consent = false;
            this.timerService.reset();
            this.router.navigate([Path.ESRAreYouSure]);

            this.progress.progressStatus[Progress.ESR] = 4;

            super.gtag(GAData.Button, GAData.no_BC);
      }

      public methodChanged() {
            if (this.data.CESP.contactMethod == '1'
                  && this.data.contact.address.chk_international != 'Y') {

                  if ( Util.isEmpty(this.data.CESP.firstArea) &&
                       Util.isEmpty(this.data.CESP.firstNumber1) &&
                       Util.isEmpty(this.data.CESP.firstNumber2) &&
                       Util.isEmpty(this.data.CESP.firstExt) ) {
                        this.data.CESP.firstArea = this.data.contact.phoneArea;
                        this.data.CESP.firstNumber1 = this.data.contact.phoneNumber1;
                        this.data.CESP.firstNumber2 = this.data.contact.phoneNumber2;
                        this.data.CESP.firstExt = this.data.contact.phoneExt;
                  }

                  if ( Util.isEmpty(this.data.CESP.secondArea) &&
                       Util.isEmpty(this.data.CESP.secondNumber1) &&
                       Util.isEmpty(this.data.CESP.secondNumber2) &&
                       Util.isEmpty(this.data.CESP.secondExt) ) {
                        this.data.CESP.secondArea = this.data.contact.daytimePhoneArea;
                        this.data.CESP.secondNumber1 = this.data.contact.daytimePhoneNumber1;
                        this.data.CESP.secondNumber2 = this.data.contact.daytimePhoneNumber2;
                        this.data.CESP.secondExt = this.data.contact.daytimeExt;
                  }

            } else {
                  this.data.CESP.firstArea = '';
                  this.data.CESP.firstNumber1 = '';
                  this.data.CESP.firstNumber2 = '';
                  this.data.CESP.firstExt = '';
                  this.data.CESP.secondArea = '';
                  this.data.CESP.secondNumber1 = '';
                  this.data.CESP.secondNumber2 = '';
                  this.data.CESP.secondExt = '';
            }
      }

      getBirthDate(birthday: string) {
            let birthDateArray = birthday.split("-");
            let month = this.translateService.instant('shared.date.' + Number.parseInt(birthDateArray[1]));
            return month + " " + birthDateArray[2] + ", " + birthDateArray[0];
      }

      public keyPress(event:any, code: string) {
            if ( code == 'consent' && event.keyCode == 13 ) {
                  this.notAgreeConsClose();
            }else if( code == 'disclaimer' && event.keyCode == 13 ){
                  this.notAgreeDiscClose();
            }else if( code == 'notice' && event.keyCode == 13){
                  this.notAgreeNoticeClose();
            }
      }

      @HostListener('document:keydown.escape', ['$event'])
      public escape(){
            if(this.noticeBoxOpen) {
                  this.notAgreeNoticeClose();
            }
            if(this.discBoxOpen){
                  this.notAgreeDiscClose();
            }
            if(this.consBoxOpen){
                  this.notAgreeConsClose();
            }
     }
      validate(code: string){
            if(code === 'pc' && Util.isEmpty(this.data.CESP.postalCode )){
                  this.error_postalCode = 'ESR_main.errPostalCodeEmpty';
            }

            if(code === 'country' && Util.isEmpty(this.data.CESP.country )){
                  this.error_country = 'ESR_main.errCountryEmpty';
            }

            if(code === 'category' && Util.isEmpty(this.data.CESP.category )){
                  this.error_category = 'ESR_main.errCategory';
            }
            
            if(code === 'promoter' && Util.isEmpty(this.data.CESP.promoter )){
                  this.error_promoter = 'ESR_main.errSelToHear';
            }

            if(code === 'contact' && Util.isEmpty(this.data.CESP.contactMethod )){
                  this.error_contactMethod = 'ESR_main.errContactMethod';
            }

            if(code === 'email' && Util.isEmpty(this.data.CESP.contactEmail )){
                  this.error_email = 'ESR_main.errEmailEmpty';
            }else if(code === 'email' &&  !Util.emailValidate(this.data.CESP.contactEmail )){
                  this.error_email = 'ESR_main.errEmailInvalid';
            }

            if(code.startsWith('phone')) {
                  if(Util.isEmpty(this.data.CESP.firstArea)
                              && Util.isEmpty(this.data.CESP.firstNumber1)
                              && Util.isEmpty(this.data.CESP.firstNumber2)) {
                        this.error_phoneNumber = "ESR_main.phoneNumberEmpty"; 
                  }else if(this.data.CESP.firstArea.length != 3
                              || this.data.CESP.firstNumber1.length != 3
                              || this.data.CESP.firstNumber2.length != 4){
                        this.error_phoneNumber = "ESR_main.phoneNumberInvalid";                  
                  }
            }

            if(code.startsWith('secondPhone')) {
                  if(Util.isEmpty(this.data.CESP.secondArea)
                              && Util.isEmpty(this.data.CESP.secondNumber1)
                              && Util.isEmpty(this.data.CESP.secondNumber2)) {
                        this.error_secondPhoneNumber = ""; 
                  }else if(   this.data.CESP.secondArea.length != 3
                              || this.data.CESP.secondNumber1.length != 3
                              || this.data.CESP.secondNumber2.length != 4){
                        this.error_secondPhoneNumber = "ESR_main.phoneNumberInvalid";                  
                  }
            }

            if(code === 'disclaimer' && !this.data.CESP.chk_disclaimer && !this.error_disclaimer){
                  this.ESRMainValidation.setDisclaimerError();
            }

            if(code === 'consent' && !this.data.CESP.chk_consent && !this.error_consent){
                  this.ESRMainValidation.setConsentError();
            }

      }

      contactLang: string;
      deSelectLangRadio(event){
            if(this.contactLang == null){
                  this.contactLang = this.data.CESP.contactLang;
            }else if(this.data.CESP.contactLang === this.contactLang){
                  this.data.CESP.contactLang = '';
                  this.contactLang = null;
                  event.target.checked = false;
            }else{
                  this.contactLang = this.data.CESP.contactLang;
            }
      }

      /**
      selectTime($event, value: string){
            this.data.CESP.contactTime = this.data.CESP.contactTime == undefined ? 0 : this.data.CESP.contactTime;
            
            setTimeout(() => {
                  let isChecked = $event.target.offsetParent.querySelector('input').checked;
                  if(value === '1' && isChecked){
                        this.data.CESP.contactTime += 1; //morning
                  }else if(value === '1' && !isChecked){
                        this.data.CESP.contactTime -= 1;
                  }
                  
                  if(value === '2' && isChecked){
                        this.data.CESP.contactTime += 2; //afternoon
                  }else if(value === '2' && !isChecked){
                        this.data.CESP.contactTime -= 2;
                  }
      
                  //console.log( this.data.CESP.contactTime );
            }, 0);
           
      }
      **/

      private focus(tagId:string,ctrlId:string) {
            this.viewportScroller.scrollToAnchor(tagId);
            let ctrl = document.getElementById(ctrlId);
            if(ctrl){
                  ctrl.focus();
            }
                 
       }

}
